import {
	MOBILE_SDK_TESTS_TABLE_ID,
	WEB_SDK_TEST_TABLE_ID
} from '../../pages/dashboards-container/dashboard_consts';

const SHOW_RECENT_TEST_DEFAULT = false;
const SHOW_TEST_PATH_DEFAULT = false;

export const showRecentTestKey = 'showRecentTest';
export const showTestPathKey = 'showTestPath';

type WebSdkTableCustomConfig = {
	[showRecentTestKey]: boolean;
	[showTestPathKey]: boolean;
};

type MobileSdkTableCustomConfig = Omit<WebSdkTableCustomConfig, 'showTestPath'>;

export type CustomConfigTableType = WebSdkTableCustomConfig | MobileSdkTableCustomConfig;

export type CustomConfigTableKeys =
	| keyof WebSdkTableCustomConfig
	| keyof MobileSdkTableCustomConfig;

export const getDefaultCustomState = (tableIdPrefix: string): CustomConfigTableType => {
	if (tableIdPrefix === WEB_SDK_TEST_TABLE_ID) {
		return {
			[showRecentTestKey]: SHOW_RECENT_TEST_DEFAULT,
			[showTestPathKey]: SHOW_TEST_PATH_DEFAULT
		};
	}
	if (tableIdPrefix === MOBILE_SDK_TESTS_TABLE_ID) {
		return {
			[showRecentTestKey]: SHOW_RECENT_TEST_DEFAULT
		};
	}
	return {} as CustomConfigTableType;
};
